module.exports = __webpack_public_path__ + "static/img/post5.a5dd3a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/post5.png
// module id = DA6N
// module chunks = 0